import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { getApi, updateItemAPI } from "../util/helper";

function CustomerServicePage() {
  const location = useLocation();
  // const navigate = useNavigate();

  const { customer, service, staff } = location.state || {};
  const [selectedDays, setSelectedDays] = useState({});
  const [backendDays, setBackendDays] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [activeTab, setActiveTab] = useState("calender");
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    getApi(
      `/customer-record/customer/${customer._id}/service/${service.serviceId}`,
      (resp) => {
        // console.log(resp.data.data.service.days, "fetched from recors");
        const processedDays = {};
        const daysData = resp.data.data.service.days || {};

        Object.entries(daysData).forEach(([year, months]) => {
          Object.entries(months).forEach(([month, days]) => {
            const monthKey = `${year}-${String(month).padStart(2, "0")}`;

            if (!processedDays[monthKey]) {
              processedDays[monthKey] = [];
            }

            days.forEach((dayObj) => {
              processedDays[monthKey].push({
                day: dayObj.day,
                approval: dayObj.approval || "pending",
              });
            });
          });
        });

        setBackendDays(processedDays);
      },
      (err) => {
        console.log(err, "error from fetching customer record");
      },
    );

    getApi(
      `/invoice/service/${service.serviceId}/customer/${customer._id}`,
      (resp) => {
        // console.log(resp.data.invoices, "response fromt invoice");
        setInvoices(resp.data.invoices);
      },
      (err) => {
        console.log(err, "error");
      },
    );
  }, [service.serviceId, customer._id]);

  // Month navigation functions
  const goToPreviousMonth = () => {
    setCurrentDate(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() - 1, 1),
    );
  };

  const goToNextMonth = () => {
    setCurrentDate(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() + 1, 1),
    );
  };

  // Generate days for the current month
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth(); // 0-indexed (0 = January)
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = new Date(year, month, 1).getDay();

  // Helper function to get month key
  const getMonthKey = (year, monthIndex) =>
    `${year}-${String(monthIndex + 1).padStart(2, "0")}`;

  // Handle day selection - toggle between pending and checked
  const handleDayClick = (day) => {
    const monthKey = getMonthKey(year, month);

    // Check if this day exists in the backend days for this month
    const backendMonthDays = backendDays[monthKey] || [];
    const backendDayInfo = backendMonthDays.find((d) => d.day === day);

    if (!backendDayInfo) {
      // If the day is not from the backend, do nothing
      return;
    }

    // Get current state of days in this month
    const currentMonthDays = selectedDays[monthKey] || [];
    const existingDayInfo = currentMonthDays.find((d) => d.day === day);

    let updatedDays;
    if (existingDayInfo) {
      if (existingDayInfo.approval === "pending") {
        updatedDays = currentMonthDays.map((d) =>
          d.day === day ? { ...d, approval: "checked" } : d,
        );
      } else {
        updatedDays = currentMonthDays.map((d) =>
          d.day === day ? { ...d, approval: "pending" } : d,
        );
      }
    } else {
      const backendStatus = backendDayInfo.approval || "pending";
      const newApproval = backendStatus === "pending" ? "checked" : "pending";
      updatedDays = [...currentMonthDays, { day, approval: newApproval }];
    }

    setSelectedDays((prev) => ({
      ...prev,
      [monthKey]: updatedDays,
    }));
  };

  // Handle day double click - revert checked to pending
  const handleDayDoubleClick = (day) => {
    const monthKey = getMonthKey(year, month);

    // Check if this day exists in the backend days for this month
    const backendMonthDays = backendDays[monthKey] || [];
    const backendDayInfo = backendMonthDays.find((d) => d.day === day);

    if (!backendDayInfo) {
      // If the day is not from the backend, do nothing
      return;
    }

    const currentMonthDays = selectedDays[monthKey] || [];
    const existingDayInfo = currentMonthDays.find((d) => d.day === day);

    if (existingDayInfo && existingDayInfo.approval === "checked") {
      // Revert checked day back to pending
      const updatedDays = currentMonthDays.map((d) =>
        d.day === day ? { ...d, approval: "pending" } : d,
      );

      setSelectedDays((prev) => ({
        ...prev,
        [monthKey]: updatedDays,
      }));
    }
  };

  // Handle form submission
  const handleSubmit = () => {
    const daysData = {};
    Object.entries(selectedDays).forEach(([key, days]) => {
      const [year, month] = key.split("-");
      if (!daysData[year]) {
        daysData[year] = {};
      }
      // Convert day objects to the format expected by the backend
      daysData[year][month] = days.map((dayObj) => ({
        day: dayObj.day,
        approval: dayObj.approval,
      }));
    });

    updateItemAPI(
      `/customer-record/customer/${customer._id}/service/${service.serviceId}`,
      daysData,
      (resp) => {
        console.log("days updated successfully");
      },
      (err) => {
        console.log(err, "error updating days");
      },
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-cyan-50 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        {/* <motion.button
          className="px-3 py-1 rounded-lg text-lg font-bold text-white bg-gray-500 hover:bg-gray-600 shadow-lg"
          onClick={() => {
            navigate("/staff");
          }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Back to Staff
        </motion.button> */}
        <button
          className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
          onClick={() => window.history.back()}
        >
          ← Back
        </button>
        {/* Header Section */}
        <div className="grid grid-cols-2 sm:flex sm:flex-row justify-between items-start lg:items-center mb-8 gap-6 mt-4">
          {/* Staff Details - Top Left */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg p-6 w-full lg:w-80 sm:flex-1 col-span-2"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Staff Details
            </h2>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-gray-500">Name</p>
                <p className="font-medium">{staff?.name || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-medium">{staff?.email || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Role</p>
                <p className="font-medium">{staff?.role || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Phone</p>
                <p className="font-medium">{staff?.phone || "N/A"}</p>
              </div>
            </div>
          </motion.div>

          {/* Service Details - Top Middle */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg p-6 col-span-1 sm:flex-1 max-w-md"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Service Details
            </h2>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-gray-500">Title</p>
                <p className="font-medium">{service?.title || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Description</p>
                <p className="font-medium">{service?.description || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Duration</p>
                <p className="font-medium">
                  {service?.duration || "N/A"} minutes
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Price</p>
                <p className="font-medium">${service?.price || "0"}</p>
              </div>
            </div>
          </motion.div>

          {/* Customer Details - Right */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg p-6 w-full lg:w-80 sm:flex-1 col-span-1"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Customer Details
            </h2>
            <div className="space-y-3">
              <div>
                <p className="text-sm text-gray-500">Name</p>
                <p className="font-medium">{customer?.name || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-medium">{customer?.email || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Phone</p>
                <p className="font-medium">{customer?.phone || "N/A"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Address</p>
                <p className="font-medium">{customer?.address || "N/A"}</p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="flex flex-wrap gap-2 mb-6 pb-4 border-b border-gray-200">
          <button
            className={`py-3 px-5 font-medium text-sm rounded-full transition-all duration-300 ${
              activeTab === `calender`
                ? "bg-indigo-600 text-white shadow-md"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab("calender")}
          >
            Calender
          </button>
          <button
            className={`py-3 px-5 font-medium text-sm rounded-full transition-all duration-300 ${
              activeTab === "invoice"
                ? "bg-indigo-600 text-white shadow-md"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
            onClick={() => setActiveTab("invoice")}
          >
            Invoice
          </button>
        </div>
        {activeTab === "calender" && (
          <>
            <motion.div
              className="bg-white rounded-2xl shadow-lg p-6 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                Select Appointment Days
              </h2>

              {/* Month Navigation */}
              <div className="flex justify-between items-center mb-6">
                <button
                  onClick={goToPreviousMonth}
                  className={`px-4 py-2 ${
                    service.allowBackDate
                      ? "bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
                      : "bg-gray-300 text-gray-400 hover:bg-gray-200"
                  }  rounded-lg transition-colors`}
                  disabled={!service.allowBackDate}
                >
                  &lt; Prev
                </button>

                <h3 className="text-xl font-semibold text-gray-800">
                  {currentDate.toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </h3>

                <button
                  onClick={goToNextMonth}
                  className="px-4 py-2 bg-indigo-100 text-indigo-700 rounded-lg hover:bg-indigo-200 transition-colors"
                >
                  Next &gt;
                </button>
              </div>

              {/* Calendar Header */}
              <div className="grid grid-cols-7 gap-2 mb-4">
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                  (day) => (
                    <div
                      key={day}
                      className="text-center font-medium text-gray-600 py-2"
                    >
                      {day}
                    </div>
                  ),
                )}
              </div>

              {/* Calendar Grid */}
              <div className="grid grid-cols-7 gap-2">
                {/* Empty cells for the first week */}
                {Array.from({ length: firstDayOfMonth }).map((_, index) => (
                  <div key={`empty-${index}`} className="h-12"></div>
                ))}

                {/* Day cells */}
                {Array.from({ length: daysInMonth }).map((_, index) => {
                  const day = index + 1;
                  const monthKey = getMonthKey(year, month);

                  // Check if this day exists in the backend days for this month
                  const backendMonthDays = backendDays[monthKey] || [];
                  const backendDayInfo = backendMonthDays.find(
                    (d) => d.day === day,
                  );

                  // Check if this day is selected in our state
                  const currentMonthDays = selectedDays[monthKey] || [];
                  const selectedDayInfo = currentMonthDays.find(
                    (d) => d.day === day,
                  );

                  let bgColor = "bg-gray-200"; // Default for non-backend days
                  let textColor = "text-gray-400";
                  let isClickable = false;

                  if (backendDayInfo) {
                    isClickable = true;

                    // Determine the actual status to display
                    // If user has interacted with the day, use the selected status
                    // Otherwise, use the backend status (defaulting to pending)
                    let displayStatus = "pending"; // Default

                    if (selectedDayInfo) {
                      // User has interacted with this day, use the selected status
                      displayStatus = selectedDayInfo.approval;
                    } else {
                      // Use the status from backend if available, otherwise default to pending
                      displayStatus = backendDayInfo.approval || "pending";
                    }

                    // Apply color based on approval status
                    if (displayStatus === "checked") {
                      bgColor = "bg-indigo-500";
                      textColor = "text-white";
                    } else {
                      // pending
                      bgColor = "bg-yellow-400";
                      textColor = "text-white";
                    }
                  }

                  return (
                    <motion.button
                      key={day}
                      className={`h-12 rounded-lg flex items-center justify-center text-base font-medium transition-all duration-200 ${
                        isClickable
                          ? `${bgColor} ${textColor} hover:opacity-90 shadow cursor-pointer`
                          : "bg-gray-200 text-gray-400 cursor-not-allowed"
                      }`}
                      onClick={
                        isClickable ? () => handleDayClick(day) : undefined
                      }
                      onDoubleClick={
                        isClickable
                          ? () => handleDayDoubleClick(day)
                          : undefined
                      }
                      whileHover={isClickable ? { scale: 1.05 } : {}}
                      whileTap={isClickable ? { scale: 0.95 } : {}}
                      disabled={!isClickable}
                    >
                      {selectedDayInfo ? (
                        <span className="font-bold">{day}</span>
                      ) : (
                        day
                      )}
                    </motion.button>
                  );
                })}
              </div>

              <div className="mt-6 text-center text-sm text-gray-600">
                Selected days:{" "}
                {Object.keys(selectedDays).length > 0
                  ? Object.entries(selectedDays)
                      .map(
                        ([month, days]) =>
                          `${month}: [${days
                            .map((d) => `${d.day}(${d.approval})`)
                            .join(", ")}]`,
                      )
                      .join(", ")
                  : "None"}
              </div>
            </motion.div>

            {/* Back and Submit Buttons */}
            <div className="flex justify-center gap-4 mt-6">
              <motion.button
                className={`px-8 py-4 rounded-full text-lg font-bold text-white shadow-lg ${
                  Object.keys(selectedDays).some(
                    (month) => selectedDays[month].length > 0,
                  )
                    ? "bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                disabled={
                  !Object.keys(selectedDays).some(
                    (month) => selectedDays[month].length > 0,
                  )
                }
                onClick={handleSubmit}
                whileHover={
                  Object.keys(selectedDays).some(
                    (month) => selectedDays[month].length > 0,
                  )
                    ? { scale: 1.05 }
                    : {}
                }
                whileTap={
                  Object.keys(selectedDays).some(
                    (month) => selectedDays[month].length > 0,
                  )
                    ? { scale: 0.95 }
                    : {}
                }
              >
                Book Appointment (
                {Object.values(selectedDays).reduce(
                  (total, days) => total + days.length,
                  0,
                )}{" "}
                day
                {Object.values(selectedDays).reduce(
                  (total, days) => total + days.length,
                  0,
                ) !== 1
                  ? "s"
                  : ""}
                )
              </motion.button>
            </div>
          </>
        )}

        {activeTab === "invoice" && (
          <motion.div
            className="bg-white rounded-2xl shadow-lg p-6 mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              Invoice Records
            </h2>
            {invoices.length === 0 ? (
              <div className="text-center py-12">
                <div className="inline-block p-4 bg-gray-100 rounded-full mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                </div>
                <p className="text-gray-500 text-lg">No invoices found</p>
                <p className="text-gray-400">
                  There are currently no invoices for this service
                </p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {invoices.map((item, index) => (
                  <motion.div
                    key={index}
                    className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.1 }}
                    whileHover={{ y: -5, scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <div className="relative">
                      <img
                        src={item.imageUrl}
                        alt="Invoice"
                        className="w-full h-48 object-cover"
                      />
                      <div className="absolute top-3 right-3 bg-white/80 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-gray-700">
                        Invoice #{index + 1}
                      </div>
                    </div>
                    <div className="p-5">
                      <div className="flex justify-between items-start mb-3">
                        <div>
                          <h3 className="font-bold text-gray-800 text-lg">
                            Payment Receipt
                          </h3>
                          <p className="text-gray-500 text-sm">
                            Service Payment
                          </p>
                        </div>
                        <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold">
                          Paid
                        </div>
                      </div>
                      <div className="border-t border-gray-100 pt-3">
                        <div className="flex justify-between text-gray-600">
                          <span>Date Paid:</span>
                          <span className="font-medium">{item.time}</span>
                        </div>
                        <div className="flex justify-between text-gray-600 mt-1">
                          <span>Amount:</span>
                          <span className="font-bold text-indigo-600">
                            ₦{item.amount || "0.00"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            )}
          </motion.div>
        )}
      </div>
    </div>
  );
}

export default CustomerServicePage;
